/*
 * @Description:
 * @Author: Mayer
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: kai.zhou
 * @LastEditTime: 2020-11-13 21:37:03
 */
export default {
  lang: "英语",
  landing: {
    name1: "Open CarlcareApp",
    name2: "Make a reservation",
    name3: "Use CarlcareApp, you can check the ",
    name4: "order information at any time!",
  },
  birLanding: {
    name1: "Choose device model",
    name2: "Fault Description:",
    name3: "Click to select service store",
    name4: "Service Store:",
    name5: "Reservation Time:",
    name6: "Please describe your device problem in detail!",
    name7: "Click to select arrival time",
    name8:"Please fill in your personal information accurately so that we can contact you!",
    name9: "Available reservation time is as follows!",
    name10: "Please input your contact number",
    name11: "Price",
    name12: "Personal Information：",
    name13: "Please input your name",
    name14: "Submit",
    name15: "Cancel",
    name16: "OK",
  },
  birRecord: {
    name1: "Brand",
    name2: "Model",
    name3: "ITEM",
    name4: "PRICE",
    name5: "Friendly Reminder:",
    name6:"These prices are just for reference, and the actual price is subject to your device condition.",
    name7:"If there is no special symbol, the price unit is the local currency unit.",
    name8: "Sorry! No price info available in the current country site.",
  },
  birRules: {
    name1: "No data yet",
    name2: "Service Provider:",
    name3: "Service Brand:",
    name4: "Telephone:",
    name5: "Quantity of Order:",
    name6: "Service Rating",
    name7: "Service Environment:",
    name8: "Service Attitude:",
    name9: "Service Efficiency:",
    name10: "Service Quality:",
    name11: "Customer Evaluation ",
    name12: "",
  },
};